<template>
<!--外层包裹器-->
<div class="Container">
  <!--内层包裹器-->
  <div class="register">
    <!--标题头-->
    <!--      <h3>请输入新用户信息</h3>-->
    <!--内容区-->
    <div class="item">
      <el-form :model="createUser" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-form-item label="用户名：" prop="username" v-loading="loading">
          <el-input v-model="createUser.username" placeholder="请输入用户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" prop="telephone">
          <el-input v-model="createUser.telephone" placeholder="请输入用户联系电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model="createUser.password" placeholder="请输入用户名" clearable show-password></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input v-model="createUser.email" placeholder="请输入邮箱地址" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户描述：" prop="description">
          <el-input v-model="createUser.description" placeholder="请输入用户描述" clearable></el-input>
        </el-form-item>
        <el-form-item label="可导出案例个数：" prop="derivedNumber">
          <el-input v-model="createUser.derivedNumber" placeholder="请输入用户可导出案例个数" clearable></el-input>
        </el-form-item>


        <el-form-item label="性别：" prop="gender">
          <el-radio v-model="createUser.gender" label="1">男</el-radio>
          <el-radio v-model="createUser.gender" label="2">女</el-radio>
        </el-form-item>


        <el-form-item label="用户类型：" prop="type">
          <el-select v-model="createUser.type" placeholder="请选择用户类型">
            <el-option label="超级管理员" value="1"></el-option>
            <el-option label="数据采集员" value="2"></el-option>
            <el-option label="普通用户" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>


      <!--按钮-->
      <div class="btnSub">
        <el-button class="w1" type="info" @click.native="newUser">创建用户</el-button>
        <el-button class="w2" type="info" @click="resetForm('ruleForm')">清空</el-button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import qs from 'qs'

export default {
  name: "新建用户",
  data() {
    return {
      /*加载动画*/
      loading: false,
      rules: {
        username: [{
          required: true,
          message: '请输入用户名称',
          trigger: 'change'
        }],
        telephone: [{
          required: true,
          message: '请输入电话号码',
          trigger: 'change'
        }],
        password: [{
            required: true,
            message: '请输入密码',
            trigger: 'change'
          },
          {
            min: 6,
            max: 16,
            message: '密码在 6 到 16 位数之间',
            trigger: 'blur'
          }
        ],
        derivedNumber: [{
          required: true,
          message: '请输入可导出案例个数',
          trigger: 'change'
        }],
        type: [{
          type: 'array',
          required: true,
          message: '请选择用户类型',
          trigger: 'blur'
        }],
      },
      createUser: {
        /*电话号码*/
        telephone: '',
        /*密码*/
        password: '',
        /*用户名*/
        username: '',
        /*性别*/
        gender: '',
        /*描述*/
        description: '',
        /*邮箱*/
        email: '',
        /*可导个数*/
        derivedNumber: '',
        /*用户类型*/
        type: [],
        /*用户类型选择*/
      }

    }
  },

  methods: {
    /*
    重置表单
    */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /**
     * 创建用户
     */
    newUser() {
      this.upUser(this.createUser.telephone, this.createUser.password, this.createUser.username, this.createUser.gender, this.createUser.description, this.createUser.email, this.createUser.derivedNumber, this.createUser.type);
    },
    upUser(telephone, password, username, gender, description, email, derivedNumber, type) {
      if (telephone === '' || password === '' || username === '' || derivedNumber === '' || type === []) {
        this.$message({
          message: "请检查必填信息是否完整",
          type: 'error',
          center: true,
          duration: 1500
        })
      } else {
        // let {telephone, password, username, gender, description, email, derivedNumber, type} = {telephone, password, username, gender, description, email, derivedNumber, type};

        /*重置提交时gender的值*/
        if (this.createUser.gender === '') {
          this.createUser.gender = '0';
        }
        let formData = qs.stringify({
          telephone,
          password,
          username,
          gender,
          description,
          email,
          derivedNumber,
          type
        });
        this.loading = true;
        this.$http.post(
            '/user/um/register',
            formData, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          )
          .then((res) => {
            this.$message({
              message: '创建成功',
              type: 'success',
              center: true,
              duration: 1500
            })
            this.$nextTick(
              this.loading = false,
            );
          })
          .catch((error) => {
            console.log(error);
            this.$nextTick(
              this.loading = false,
            );
          });
        /*重置数据*/
        this.resetForm('ruleForm');
      }
    }
  }
}
</script>
<style scoped>
/*解决服务器上面会有内边距出现的问题*/
.el-main {
  padding: 0;
}

/*外层包裹器*/
.Container {
  width: 80%;
  height: 90%;
  min-height: 544px;
  margin-top: 10px;
  margin-left: 10%;
  border-radius: 30px;
  background-color: #F1F3F4;
  color: gray;
}

/*内层包裹器*/
.register {
  width: 50%;
  height: 100%;
  margin: 0 auto;
}

.item {
  border: 1px solid transparent;
  margin-top: 1%
}

.demo-ruleForm {
  margin-top: 5%;
}

/*标题*/
.register h3 {
  text-align: center;
}

/* *号的样式*/
.red {
  color: red;
}


/*按钮样式*/
.btnSub {
  display: flex;
  margin-top: 15px;
  justify-content: center;
  align-items: center;
}

/*对按钮进行定宽*/
.w1 {
  width: 100px;
  background-color: #409EFF;
}

.w2 {
  width: 100px;
  background-color: #E6A23C;
}
</style>



// WEBPACK FOOTER //
// src/user/newUser.vue